module.exports = __webpack_public_path__ + "static/viola_cn-938e2e4942038ecc213fdab18fbd0703.pdf";